<script setup lang="ts">
defineProps<{
  color: string;
  ral: string;
  areaPart: string;
}>();
</script>

<template>
  <div>
    <div
      class="min-[1300px]:hidden flex items-stretch justify-between p-2 bg-lumar-gray-10 rounded-lg"
    >
      <div class="flex flex-col justify-between">
        <span class="text-xs text-lumar-dark-gray">{{ ral }}</span>
        <span class="text-lumar-gray font-semibold">{{ $t(areaPart) }}</span>
      </div>
      <div class="h-12 w-12 rounded-sm" :style="{ background: color }" />
    </div>
    <div class="hidden min-[1300px]:flex flex-col gap-8 p-4 bg-lumar-gray-10 rounded-lg">
      <div class="h-[140px] w-full rounded-sm" :style="{ background: color }"></div>
      <div class="grid grid-rows-2">
        <div class="truncate">
          <span class="text-xs text-lumar-dark-gray">{{ ral }}</span>
        </div>
        <span class="text-lumar-gray font-semibold">{{ $t(areaPart) }}</span>
      </div>
    </div>
  </div>
</template>
